import instance from "./api";

export const fetchWaitingDrivers = () =>
  instance
    .get("/dashboard/waiting-drivers")
    .then((r) => r.data?.data?.drivers ?? []);

export const fetchAcceptedDrivers = () =>
  instance.get("/dashboard/accepted-drivers").then((r) => r.data ?? []);

export const fetchRejectedDrivers = () =>
  instance
    .get("/dashboard/rejected-drivers")
    .then((r) => r.data?.data?.drivers ?? []);

export const acceptDriver = (id) =>
  instance.patch(`/dashboard/accept-driver?id=${id}`);

export const rejectDriver = ({ id, reason }) =>
  instance.patch(
    `/dashboard/reject-driver?id=${id}&rejection_reason=${encodeURIComponent(
      reason
    )}`,
    { status: "REJECTED" }
  );

export const blockDriver = (driverId, isBlocked) =>
  instance.patch(
    `/dashboard/blocked-driver?driver-id=${driverId}&is_blocked=${isBlocked}`
  );

export const updateDriver = ({ id, data }) =>
  instance.patch("/dashboard/update-driver", { id, ...data });

export const fetchDriverById = (id) =>
  instance
    .get(`/dashboard/profile-driver?id=${id}`)
    .then((r) => r.data?.data ?? {});
